// extracted by mini-css-extract-plugin
module.exports = {"favoritesList":"CFavorites_favoritesList__1Uk0B","forceOpenSection":"CFavorites_forceOpenSection__3kwmX","favoritesFolderHeader":"CFavorites_favoritesFolderHeader__2JnWz"};